import { loyalty_video_id } from 'src/consts/resource';
const SectionContent = {
  topSection: {
    en: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty.png`,
      title: 'Restaurant Loyalty Program',
      description: `Say goodbye to paper loyalty cards with Chowbus' exclusive loyalty program and increase your business volume by 25%!`,
      youtubeVideoId: loyalty_video_id,
    },
    zh: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty.png`,
      title: 'Chowbus POS系统: 北美最强餐饮会员系统',
      description: '专为餐厅定制的会员体系，涵盖会员卡、会员积分、充值预付、促销活动等功能特性',
      youtubeVideoId: loyalty_video_id,
    },
  },
  advances: {
    en: {
      title: ` Increase Revenue by 25% with Restaurant Loyalty Programs`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_feature_1.png`,
          imageAlt: 'Drive More Customer Visits',
          title: 'Drive More Customer Visits',
          description:
            'Provide diners discounts when they sign up for the restaurant’s own loyalty program to increase customer’s visit frequency and track diner performance.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_feature_2.png`,
          imageAlt: 'Connect with Customers Automatically',
          title: 'Connect with Customers Automatically',
          description:
            'Store membership cards in Apple Wallet and notify customers when they are close to your restaurant.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_feature_3.png`,
          imageAlt: 'Built Your Way to Reward and Engage Customers',
          title: 'Built Your Way to Reward and Engage Customers',
          description:
            'Utilize your own loyalty program to communicate with your guests. Set automated promos and make it easier than ever to bring in foot traffic.',
        },
      ],
    },
    zh: {
      title: `强大的餐饮会员系统帮助餐厅提升复购率`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_feature_1.png`,
          imageAlt: '全面的会员注册渠道',
          title: '全面的会员注册渠道',
          description: '桌面二维码、平板、扫码、智能点单机等多触点均能注册会员，有效转化顾客会员',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_feature_2.png`,
          imageAlt: '多样的营销活动',
          title: '多样的营销活动',
          description: '餐厅可以在POS后台设置礼品卡、优惠券、买赠活动等营销活动，满足不同场景的营销需求',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_feature_3.png`,
          imageAlt: '有效的促活方式',
          title: '有效的促活方式',
          description: '可以通过短信提醒顾客近期优惠活动，还可即时提醒在您餐厅附近的会员进店消费',
        },
      ],
    },
  },

  features: {
    en: {
      title:
        'With the Restaurant Loyalty Program powered by Chowbus, your customer relationships can become even stronger and more profitable.',
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: 'Turn first-time guests into regulars',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_1.png`,
          items: [
            {
              desc: 'You can get thesaurus of Restaurant Loyalty Members within just a few months. The New Member Registration powered by Chowbus has never been earlier.',
            },
            {
              desc: `When a customer comes in for the first time, we motivate this customer to register as a Loyalty member immediately . We communicate various promotional information to make this customer your repeated customer from then on. You can set the first-order discount as an incentive, such as “Sign up today, to get 10% OFF on your first order‘’.`,
            },
            {
              desc: 'Points based on spend, or sign up. Restaurants have full customization for points to earn and spend.',
            },
          ],
        },

        {
          layout: 'row',
          direction: 'reverse',
          title: 'Boosting repeat business',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_2.png`,
          items: [
            {
              desc: 'The restaurant loyalty program plays a major role in customer retention. It is the easiest way to increase your business volume by 25%!',
            },
            {
              desc: 'Access more customer order data to build a seamless brand experience that keeps customers coming back for more. Send personalized notifications for marketing that’s never boring.',
            },
            {
              desc: `Set automated promos and make it easier than ever to bring in foot traffic. When a customer has not come back for a period of time, the loyalty program allows us to send customized promotions to them, such as "Your favorite brown sugar cloud milk tea is BOGO. Make a purchase before Friday to get double points. Don't miss it!"`,
            },
          ],
        },
        {
          layout: 'row',
          direction: 'normal',
          title: 'Digital Membership + Physical Gift Card',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_3.png`,
          items: [
            {
              desc: 'Restaurant Loyalty Program offers both digital membership and wallet and physical prepaid gift card.',
            },
            {
              desc: 'Loyalty members can either add prepaid value into their loyalty digital wallet or they can purchase a physical prepaid gift card. Members will receive a SMS notification for the amount added and the current balance.',
            },
            {
              desc: 'Store membership cards in Apple Wallet and notify customers when they are close to your restaurant. It’s easier than ever to hook your customers up with loyal membership to keep them coming back.',
            },
          ],
        },
      ],
    },
    zh: {
      title: '善用会员体系，大幅提升营业额',
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: '高效转化新顾客至回头客',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_1.png`,
          items: [
            {
              desc: `Chowbus POS将会员体系融入到所有产品中，平板点餐、扫码点餐、自助点餐机、餐厅网页点餐等多渠道，均能注册会员，有效提升会员数量`,
            },
            {
              desc: `设置新会员专属福利提升顾客转化为会员的比率`,
            },
            { desc: '新顾客注册为会员后，可以通过发送优惠活动信息，将新顾客转化为忠实的回头客' },
          ],
        },
        {
          layout: 'row',
          direction: 'reverse',
          title: '大幅提升客户复购率',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_2.png`,
          items: [
            {
              desc: '可以通过设置消费返现比例，显著增加会员的复购率',
            },
            { desc: `发送定制化促销信息，提升订单转化率，如“您最喜欢的XX产品正在买一送一，现在购买还享双倍积分”` },
            {
              desc: `通过提供充值卡和礼品卡选项，让顾客在快速结账、享受优惠的同时，增加餐厅资金回流速度`,
            },
            {
              desc: `顾客将会员卡添加到Apple Wallet后，餐厅可以即时提醒附近的会员进店消费`,
            },
          ],
        },
        {
          layout: 'row',
          direction: 'normal',
          title: '轻松管理会员体系',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_3.png`,
          items: [
            {
              desc: '在Chowbus APP统一管理餐厅会员服务，根据不同的获客需求设置新人优惠券、生日福利、消费返现、会员积分、礼品卡等会员服务 ',
            },
            {
              desc: '跨店会员、跨店积分满足集团餐厅集中管理会员服务的诉求',
            },
            { desc: '顾客可以将电子会员卡添加到手机钱包中，还可随时充值、查看余额' },
          ],
        },
      ],
    },
  },

  features2: {
    en: {
      title: `Your customers, your data, your relationships. All wrapped up in one hospitality CRM system.`,
      items: [
        {
          layout: 'column',
          direction: 'normal',
          title: '360° Guest CRM System',
          // cover: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_2_1.png`,
          covers: [
            {
              src: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_crm_2_1.png`,
              ratio: 415 / 613,
            },
            {
              src: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_crm_2_2.png`,
              ratio: 415 / 613,
            },
          ],
          items: [
            {
              desc: '7 campaigns triggered automatically, based on critical moments in a customer’s journey, like a first-time visit, a birthday, or if they’re at risk for not coming back.',
            },
            {
              desc: `AutoPilot is fully automatic, you only need to decide whether to turn on the specific autopilot scene in the settings.`,
            },
            {
              desc: 'You can also create and edit the campaign, and send it to the specified user group.',
            },
          ],
        },

        {
          layout: 'column',
          direction: 'normal',
          title: 'Smart Database Segmentation',
          // cover: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_2_2.png`,
          // coverRatio: 415 / 1280,
          covers: [
            {
              src: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_crm_2_3.png`,
              ratio: 415 / 613,
            },
            {
              src: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_crm_2_4.png`,
              ratio: 415 / 613,
            },
          ],
          items: [
            {
              desc: 'SMS sending dashboard in loyalty overview report.',
            },
            {
              desc: 'Support to view the usage of the current Plan, for example, $99 Plan contains 2000 segments，and 1866 have been used.',
            },
          ],
        },
      ],
    },
    zh: {
      title: 'Chowbus餐饮会员系统不仅帮助您触达顾客，还为您提供完整的数据报表',
      items: [
        {
          layout: 'column',
          direction: 'normal',
          title: '专为餐厅定制的全方位客户关系管理系统',
          // cover: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_2_1.png`,
          // coverRatio: 415 / 1280,
          covers: [
            {
              src: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_crm_2_1.png`,
              ratio: 415 / 613,
            },
            {
              src: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_crm_2_2.png`,
              ratio: 415 / 613,
            },
          ],
          items: [
            {
              desc: `针对7个场景（新注册、首单消费、会员生日、提醒复购等），餐厅可以设置是否要自动发送短信，也可以编辑短信模板`,
            },
            {
              desc: `打开相应的自动发送开关后，系统对触发相应条件的顾客自动发送短信`,
            },
            { desc: '如有特殊活动，可以手动创建营销短信，发送给对应的目标用户群（所有会员、新注册会员、低频会员等）' },
          ],
        },
        {
          layout: 'column',
          direction: 'normal',
          title: '完整的数据报表赋能营销决策',
          // cover: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_2_2.png`,
          covers: [
            {
              src: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_crm_2_3.png`,
              ratio: 415 / 613,
            },
            {
              src: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_crm_2_4.png`,
              ratio: 415 / 613,
            },
          ],
          items: [
            {
              desc: '可以在后台查看营销短信的实时数据',
            },
            { desc: '支持查看当前套餐的使用情况，例如，套餐中包含2000条免费短信，已使用1866条' },
          ],
        },
      ],
    },
  },
  whyNotChooseChowBus: {
    en: {
      title: 'Why Restaurants Choose Chowbus',
    },
    zh: {
      title: '他们选择Chowbus餐饮会员系统的原因',
    },
  },
  customerVoiceInfos: [
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-machimachi.jpeg`,
      productLine: 'Loyalty',
      desc: {
        zh: `“自从我们在纽约中城开了第一家店之后，就一直使用Chowbus POS和他们的智能⾃助点餐机。之后我们还加入了餐厅专属会员系统。客人在智能⾃助点餐机上点完餐后，系统就会自动弹出弹窗，引导客人注册成餐厅会员。这个系统在智能⾃助点餐机的基础上，自动地将新顾客转化成忠实的回头客。用了一段时间后，我们的客单价提高了18%，餐厅利润提高了，用户关系也变得更加牢固了。我们对这个效果非常满意！”`,
        en: `“We’ve started using Chowbus POS Kiosk since we opened our first location in Midtown, New York. Later, we decided to add the Loyalty Program addition to the Kiosk. When new customers come to the store, they can directly order from the Kiosk, and the system will encourage them to sign up for the restaurant loyalty program. By leveraging the Kiosk and Loyalty Program together, the average order size increased 18%. Our customer relationships became even stronger and more profitable.”`,
      },
      restaurantName: { zh: 'Machi Machi', en: 'Machi Machi' },
      location: { zh: '纽约', en: 'New York, NY' },
      link: '/business-types/boba-tea-dessert/machi-machi',
    },
  ],
};

export default SectionContent;
